// ----------------------------------------------------------------------
// <copyright file="Izenda.QuerySourceTypeContent.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Izenda.QuerySourceTypeContent component
 */
!(function() {
  var React = require('react');
  var ReactDOM = require('react-dom');
  var classnames = require('classnames');
  var connect = require('share/enhancers/Izenda.Connect');
  var ScrollBox = require('share/components/controls/Izenda.ScrollBox');
  var Dimensions = require('share/components/hoc/Izenda.Dimensions');
  var QuerySourceTypeList = require('./Izenda.QuerySourceTypeList');
  var QuerySourceTypeDetails = require('./Izenda.QuerySourceTypeDetails');
  var QuerySourceTypeConfig = require('logic/data/Izenda.QuerySourceTypeConfig').QUERY_SOURCE_TYPE;
  var observable = require('mobx').observable;
  const { indexOf } = require('lodash/fp');

  var QuerySourceTypeContent = React.createClass({
    propTypes: {
      store: React.PropTypes.object.isRequired
    },

    componentWillMount: function() {
      this.uiStore = observable({
        defaultHeight: 0
      });
    },

    componentDidMount: function() {
      var domNode = ReactDOM.findDOMNode(this);
      if (this.uiStore.defaultHeight != domNode.clientHeight) {
        this.uiStore.defaultHeight = domNode.clientHeight;
      }
    },

    render: function() {
      var props = this.props;
      var store = props.store;
      var height = props.height > 0 ? props.height : this.uiStore.defaultHeight;
      var querySourceIndex = indexOf(store.selectedQuerySource, store.querySourceList);

      return (
        <div className="izenda-Wrapper-content">
          <ScrollBox>
            <section className="u_paddingLeftRight u_fullHeight">
              {/* list of stored procedure*/}
              <QuerySourceTypeList
                store={store}
                querySourceType={this.props.querySourceType}
                height={height}
                searchProperty={props.searchProperty}
                searchValue={props.searchValue}
                isNotHighLight={props.isNotHighLight}
                isLoading={props.isLoading}
              />

              {/* details of selected stored procedure (if any)*/}
              {store.selectedQuerySource &&
                props.querySourceType !== QuerySourceTypeConfig.FUNCTION && (
                  <QuerySourceTypeDetails
                    store={store.selectedQuerySource}
                    querySourceType={store.querySourceType}
                    querySourceIndex={querySourceIndex}
                    height={height}
                    searchProperty={props.searchProperty}
                    searchValue={props.searchValue}
                  />
                )}
            </section>
          </ScrollBox>
        </div>
      );
    }
  });

  module.exports = connect(Dimensions)(QuerySourceTypeContent);
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/DataModel/QuerySourceType/Izenda.QuerySourceTypeContent.jsx